// NOTE: JQuery validator has awful typing support as of now, need to wait for it to be updated

import { handleValidation, IHandleValidation } from './DexeroFormValidation/handleValidation';

// Extend validator
// @ts-ignore
$.validator.addMethod(
  'filesize',
  function filesize(value: any, element: HTMLElement, param: number) {
    // param = size (en bytes)
    // element = element to validate (<input>)
    // value = value of the element (file name)
    // @ts-ignore
    if (typeof element.files[0] === 'undefined' || element.files[0] === null) {
      return true;
    }
    return (
      this.optional(element) === true ||
      this.optional(element) === 'dependency-mismatch' ||
      // @ts-ignore
      element.files[0].size <= Number(param)
    );
  }
);

$.validator.addMethod('autoCompleteCheck', function autoCompleteCheck(value, element) {
  // element = element to validate (<input>)
  // value = value of the element (user input text)
  const $element = $(element);
  const val = $element.val();
  const $dropDown = $element.autocomplete('widget');
  const $lis = $dropDown.find('li');
  let hasMatch;

  // If edit page is called, input will have value, but there will be no autocomplete widget li elms and no change instance has been triggered
  // This means we've previously passed validation
  if (val !== '' && !$dropDown.hasClass('has-change')) {
    hasMatch = true;
  } else {
    hasMatch = false;
    // Loop through options and find if match is correct
    if ($lis.length) {
      $lis.each((_, li) => {
        const thisValue = $(li).text();
        if (thisValue === value) {
          hasMatch = true;
        }
      });
    }
  }
  return (
    // @ts-ignore
    this.optional(element) === true || this.optional(element) === 'dependency-mismatch' || hasMatch
  );
});

$.validator.addMethod('emptyWarning', (value, element) => {
  // element = element to validate (<input>)
  // value = value of the element (potentially empty but not required)
  // On first submit, if the value is empty show the warning, and then remove the check for the next submit
  const $element = $(element);
  const id = $element.attr('id');
  const name = $element.attr('name');
  const $label = $(`label[for="${id}"]`);
  let elementMsgWarning = '';
  if ($element.attr('data-msg-warning') !== undefined) {
    elementMsgWarning = $element.data('msg-warning');
  } else if (typeof window.formEmptyWarningMsg !== 'undefined') {
    elementMsgWarning = window.formEmptyWarningMsg;
  }
  // Since we are removing the warning after the first submit, we'll add an icon as a persitant warning to show the user this field should be filled out, but is not required
  const icon = `<span class="tooltip-warning badge badge-warning badge-md tooltips" role="tooltip" tabindex="0" data-container="body" data-placement="top" data-original-title="${elementMsgWarning}"><span class="fa fa-exclamation" aria-hidden="false"></span></span>`;

  if ((value === '' || value === undefined) && $element.data('empty-warning') === true) {
    $element
      .removeData('empty-warning')
      .attr('data-empty-warning', 'false')
      .data('empty-warning', false);
    if ($element.hasClass('matrix-input')) {
      $element.closest('tr').find('> th').append(icon).find('.tooltip-warning').tooltip();
    } else if ($element.hasClass('fieldset-input-group')) {
      $(`#label_${name}`).append(icon).find('.tooltip-warning').tooltip();
    } else if ($element.hasClass('note-editable')) {
      $element.closest('.form-group').find('label').append(icon).find('.tooltip-warning').tooltip();
    } else {
      $label.append(icon).find('.tooltip-warning').tooltip();
    }
    return false;
  }
  return true;
});

$.validator.addMethod('emailStrict', function emailStrict(value, element) {
  // Default validator allows test@test / now we force test@test.com
  // element = element to validate (<input>)
  // value = value of the element (file name)
  const result = window.window.DexeroCoreApp._validateEmail(value);
  return (
    // @ts-ignore
    this.optional(element) === true || this.optional(element) === 'dependency-mismatch' || result
  );
});

$.validator.addMethod('hasSubCardsCheck', (value, element) => {
  // element = element to validate (<input>)
  // value = value of the element (user input text)
  const $element = $(element);
  const subCardDisplay = $element.data('display'); // table or panel
  const $mainFieldSubFormHolder = $element.parent('.fieldSubForm');
  let $childElms;

  // Get eligable child elements based on display type
  if (subCardDisplay === 'table') {
    $childElms = $mainFieldSubFormHolder.find('table tbody tr:not(.no-result)');
  } else if (subCardDisplay === 'panel') {
    $childElms = $mainFieldSubFormHolder.find('.panel-group .panel');
  }
  // Check if it has any children
  // @ts-ignore
  const hasSubCards = !!$childElms.length;

  return hasSubCards;
});

$.validator.addMethod('reCaptchaCheck', (value, element) => {
  const $element = $(element);
  if (!$element.val()) {
    DCA._validateReCaptchaFields(value, element);
    return false;
  }

  return true;
});

$.validator.addMethod('allowedDate', function addMethod(value, element) {
  const $element = $(element);
  let valid;
  // Check which days are allowed for the end date input. If no allowed days are specified all days will be allowed
  if (
    typeof $element.data('allowed-days') === 'undefined' ||
    $element.hasClass('ignore-days-restriction') ||
    $element.val() === ''
  ) {
    valid = true;
  } else {
    const datepicker = $element.data('datepicker');
    const { weekdays } = datepicker;
    const dateValue = datepicker.getMomentOfValue();
    const dateValueDay = dateValue.day();
    const enabledDaysArray: number[] = [];

    $.each($element.data('allowed-days').split(','), (_, val) => {
      const dayId = weekdays[val];
      enabledDaysArray.push(dayId);
    });

    valid = enabledDaysArray.indexOf(dateValueDay) !== -1;
  }
  return (
    // @ts-ignore
    this.optional(element) === true || this.optional(element) === 'dependency-mismatch' || valid
  );
});

$.validator.addMethod('strictValidDate', function strictValidDate(value, element) {
  const $element = $(element);
  const valid = $element.data('datepicker').getMomentOfValue(true).isValid();
  return (
    // @ts-ignore
    this.optional(element) === true || this.optional(element) === 'dependency-mismatch' || valid
  );
});

$.validator.addMethod('autoCompleteCheck', function autoCompleteCheck(value, element) {
  // element = element to validate (<input>)
  // value = value of the element (user input text)
  const $element = $(element);
  const val = $element.val();
  const $dropDown = $element.autocomplete('widget');
  const $lis = $dropDown.find('li');
  let hasMatch;

  // If edit page is called, input will have value, but there will be no autocomplete widget li elms and no change instance has been triggered
  // This means we've previously passed validation
  if (val !== '' && !$dropDown.hasClass('has-change')) {
    hasMatch = true;
  } else {
    hasMatch = false;
    // Loop through options and find if match is correct
    if ($lis.length) {
      $lis.each((_, li) => {
        const thisValue = $(li).text();
        if (thisValue === value) {
          hasMatch = true;
        }
      });
    }
  }
  return (
    // @ts-ignore
    this.optional(element) === true || this.optional(element) === 'dependency-mismatch' || hasMatch
  );
});

$.validator.addMethod('signatureCheck', function signatureCheck(value, element) {
  // element = hidden signature input
  // value = value of the element (user input text)
  const $element = $(element);
  const val = $element.val();

  return (
    // @ts-ignore
    this.optional(element) === true ||
    // @ts-ignore
    this.optional(element) === 'dependency-mismatch' ||
    val !== ''
  );
});

export interface IDexeroFormValidation {
  handleValidation: IHandleValidation;
}

const DexeroFormValidation: IDexeroFormValidation = {
  // validation using icons
  handleValidation,
};

export default DexeroFormValidation;
